/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { getColor } from 'helpers/utils';
import {
  GridComponent,
  TooltipComponent,
  TitleComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import BasicECharts from 'components/common/BasicEChart';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const pieColors = [
  "#3366CC", // 1 - Blue
  "#DC3912", // 2 - Red
  "#FF9900", // 3 - Orange
  "#109618", // 4 - Green
  "#990099", // 5 - Purple
  "#0099C6", // 6 - Cyan
  "#DD4477", // 7 - Pink
  "#66AA00", // 8 - Lime Green
  "#B82E2E", // 9 - Dark Red
  "#316395", // 10 - Steel Blue
  "#994499", // 11 - Violet
  "#22AA99", // 12 - Teal
  "#AAAA11", // 13 - Olive
  "#6633CC", // 14 - Indigo
  "#E67300", // 15 - Amber
  "#8B0707", // 16 - Burgundy
  "#651067", // 17 - Deep Purple
  "#329262", // 18 - Sea Green
  "#5574A6", // 19 - Slate Blue
  "#3B3EAC", // 20 - Royal Blue
  "#B77322", // 21 - Brownish Orange
  "#16D620", // 22 - Bright Green
  "#B91383", // 23 - Magenta
  "#F4359E", // 24 - Hot Pink
  "#9C5935"  // 25 - Copper
];

const getOptions = (data, radius) => ({
  color: pieColors,

  tooltip: {
    padding: [7, 10],
    transitionDuration: 0,
    backgroundColor: getColor('100'),
    borderColor: getColor('300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    formatter: params =>
      `<strong>${params.data.name}:</strong> ${params.percent}%`
  },
  series: [
    {
      name: '',
      type: 'pie',
      radius,
      avoidLabelOverlap: false,
      // emphasis: {
      //   scale: false
      // },
      itemStyle: {
        borderWidth: 1,
        // borderRadius: 10,
        borderColor: getColor('card-bg')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 23,
        color: getColor('dark')
      },
      data
    }
  ]
});

const PieItem = ({ item, index, total }) => {
  const { name, color, value, prefix } = item;
  console.log("pie item", color)
  const percentage = ((value * 100) / total).toFixed(0);
  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semi-bold fs--2`}
    >
      <p className="mb-1">
        <FontAwesomeIcon
          icon="circle"
          className={`me-2 text-${color || 'text-info'}`}
          style={{ color: color }}
        />
        {name} ({prefix}
        {value})
      </p>
      <div className="d-xxl-none">{percentage}%</div>
    </Flex>
  );
};

export default function PieChartWidget(props) {
  let transformedData = [];
  let total = 0;
  console.log("PIE DATA", props.data);
  props.data.forEach((item, index) => {
    total = total + item.total;
    transformedData.push({
      id: index,
      name: item.type,
      value: item.total,
      color: pieColors[index],
      prefix: 'prefix' in item ? item['prefix'] : ''
    });
  });

  return (
    <>
      <div>
        <Row>
          <Col className="text-start ps-4" style={{
            overflowY: "auto",
            maxHeight: "100%",
            paddingRight: "1rem",
            borderRight: "1px solid #ddd",
          }}>

            {transformedData.map((item, index) => (
              <PieItem item={item} index={index} key={index} total={total} />
            ))}
          </Col>
          <Col className="text-end">
            <div style={{ display: "inline-block", width: "100%", maxWidth: "400px" }}>
              <BasicECharts
                echarts={echarts}
                options={getOptions(transformedData, ['100%'])}
                style={{ height: "100%" }}
              />
            </div>

          </Col>
        </Row>
      </div>
    </>
  );
}

PieItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    prefix: PropTypes.string
  }),
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

PieChartWidget.propTypes = {
  data: PropTypes.array
};
